import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Storefront Architecture", desc: "Conversion-first storefronts built for discovery, trust, and checkout completion." },
  { title: "Catalog Operations", desc: "Scalable product information systems for complex inventory and merchandising." },
  { title: "Payment & Logistics", desc: "Reliable payment, tax, and fulfillment orchestration across your target regions." },
  { title: "Retention Systems", desc: "Post-purchase journeys that increase repeat orders and customer lifetime value." },
  { title: "Marketplace Integration", desc: "Sync commerce operations across D2C, marketplaces, and offline channels." },
  { title: "Revenue Analytics", desc: "Cohort and funnel intelligence that drives smarter merchandising decisions." },
];

const ECommerce = () => (
  <StitchFeaturePage
    label="WEB & DIGITAL"
    title="Commerce platforms that"
    titleAccent="compound revenue."
    subtitle="End-to-end e-commerce engineering for brands that care about margins, velocity, and scale readiness."
    features={features}
    ctaLabel="LAUNCH ECOMMERCE"
  />
);

export default ECommerce;